import {
  SET_SCREEN_WIDTH,
  SET_SCREEN_WIDTH_SUCCESS,
  SET_SCREEN_WIDTH_FAILURE,
} from "../actionTypes";

export const setScreenWidth = (payload, callback) => ({
  type: SET_SCREEN_WIDTH,
  payload: { payload, callback },
});

export const setScreenWidthSuccess = (data) => ({
  type: SET_SCREEN_WIDTH_SUCCESS,
  payload: data,
});

export const setScreenWidthFailure = () => ({
  type: SET_SCREEN_WIDTH_FAILURE,
});
